import IN_STORE_ORDER from './in-store-order'
import IN_STORE_ORDER_IN_BATCH from './in-store-order-in-batch'
import OUT_STORE_ORDER from './out-store-order'
export default {
	'in-store-order': IN_STORE_ORDER,
	'in-store-order-in-batch': IN_STORE_ORDER_IN_BATCH,
	'out-store-order': OUT_STORE_ORDER
}
